/**
 * Переклад банера CookieYes на англійську.
 * CookieYes (безкоштовний план) має одну мову — українську (за замовчуванням). Коли сторінка англійська
 * (<html lang="en-US"> від Polylang), підміняємо тексти за стабільними атрибутами data-cky-tag
 * і за slug категорії (id тіла акордеона ckyDetailCategory<slug>Body). Українські тексти не чіпаємо.
 * Банер малює сам плагін асинхронно (і перемальовує), тому слухаємо появу вузлів у <body>.
 */
const EN = {
  title: 'We value your privacy',
  description:
    'We use cookies to analyse site traffic and improve how it works. By clicking “Accept all”, you consent to their use.',
  'settings-button': 'Customise',
  'reject-button': 'Reject all',
  'accept-button': 'Accept all',
  'detail-title': 'Customise consent preferences',
  'detail-description':
    'We use cookies to run the site and analyse traffic. Choose which categories to allow below. Necessary cookies are required for basic site functions and are always active. Analytics cookies help us understand how visitors use the site and are enabled only with your consent.',
  'always-active': 'Always active',
  'detail-reject-button': 'Reject all',
  'detail-save-button': 'Save my preferences',
  'detail-accept-button': 'Accept all',
  'detail-close': 'Close',
  'show-desc-button': 'Show more',
  'hide-desc-button': 'Show less',
};

// назви й описи категорій за slug
const CATEGORIES = {
  necessary: [
    'Necessary',
    'Necessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your consent preferences. These cookies do not store any personally identifiable data.',
  ],
  functional: [
    'Functional',
    'Functional cookies help perform certain functionalities like sharing the content of the website on social media platforms, collecting feedback, and other third-party features.',
  ],
  analytics: [
    'Analytics',
    'Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information on metrics such as the number of visitors, bounce rate, traffic source, etc.',
  ],
  performance: [
    'Performance',
    'Performance cookies are used to understand and analyse the key performance indexes of the website which helps in delivering a better user experience for the visitors.',
  ],
  advertisement: [
    'Advertisement',
    'Advertisement cookies are used to provide visitors with customised advertisements based on the pages you visited previously and to analyse the effectiveness of the ad campaigns.',
  ],
};

function setText(el, text) {
  const paragraphs = el.querySelectorAll('p');
  const target = paragraphs[0] || el;
  if (target.textContent !== text) target.textContent = text;
  for (let i = 1; i < paragraphs.length; i++) paragraphs[i].remove();
  // кнопки мають ще й aria-label
  if (el.hasAttribute('aria-label') && el.getAttribute('aria-label') !== text) el.setAttribute('aria-label', text);
}

function translate() {
  if (!/^en/i.test(document.documentElement.lang)) return;

  document.querySelectorAll('[data-cky-tag]').forEach((el) => {
    const text = EN[el.dataset.ckyTag];
    if (text === undefined) return;
    // кнопка закриття — лише aria-label (всередині іконка)
    if (el.dataset.ckyTag === 'detail-close') el.setAttribute('aria-label', text);
    else setText(el, text);
  });

  document.querySelectorAll('[data-cky-tag="detail-category-title"]').forEach((btn) => {
    const slug = (btn.getAttribute('aria-controls') || '').replace(/^ckyDetailCategory|Body$/g, '');
    const cat = CATEGORIES[slug];
    if (!cat) return;
    setText(btn, cat[0]);
    const desc = btn.closest('.cky-accordion')?.querySelector('[data-cky-tag="detail-category-description"]');
    if (desc) setText(desc, cat[1]);
  });
}

export default function cookieBanner() {
  if (!/^en/i.test(document.documentElement.lang)) return;
  let queued = false;
  const run = () => {
    queued = false;
    translate();
  };
  new MutationObserver(() => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(run);
    }
  }).observe(document.body, { childList: true, subtree: true });
  translate();
}
